import {useInitAbTest} from 'modules/ab-tests/hooks/useInitAbTest';
import {useGetAbTest} from 'modules/ab-tests/hooks/getAbTest';
import {AB_TOP_FILTERS} from 'modules/ab-tests/constants';

export const useInitAbTopFilters = () => {
    return useInitAbTest({abTestName: AB_TOP_FILTERS});
};

export const useGetAbTopFilters = () => {
    return useGetAbTest({abTestName: AB_TOP_FILTERS});
};
